'use client';
import React, { useState, useEffect } from 'react';
import Link from 'next/link';

export default function Footer() {
  const [year, setYear] = useState(2024);

  useEffect(() => {
    setYear(new Date()?.getFullYear());
  }, []);

  const footerLinks = {
    Resources: [
      { href: '/categories', label: 'Browse Paddles' },
      { href: '/compare', label: 'Compare Tool' },
      { href: '/top-paddles', label: 'Buying Guide' },
      { href: '/top-paddles', label: 'Top Paddles' },
    ],
    'Get in touch': [
      { href: '/compare', label: 'Suggest a paddle' },
      { href: '/compare', label: 'Partnerships' },
      { href: '/compare', label: 'Contact us' },
    ],
    Categories: [
      { href: '/categories/carbon-fiber', label: 'Carbon Fiber' },
      { href: '/categories/fiberglass', label: 'Fiberglass' },
      { href: '/categories/tournament', label: 'Tournament' },
      { href: '/categories/beginner', label: 'Beginner' },
      { href: '/categories', label: 'All categories' },
    ],
    PaddleVS: [
      { href: '/', label: 'About us' },
      { href: '/top-paddles', label: 'How we score' },
      { href: '/', label: 'Editorial guidelines' },
    ],
    Legal: [
      { href: '/', label: 'Privacy' },
      { href: '/', label: 'Terms' },
      { href: '/', label: 'Imprint' },
    ],
  };

  const socials = [
    {
      href: 'https://twitter.com', label: 'Twitter',
      icon: <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.748l7.73-8.835L1.254 2.25H8.08l4.259 5.63zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
    },
    {
      href: 'https://instagram.com', label: 'Instagram',
      icon: <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
    },
    {
      href: 'https://youtube.com', label: 'YouTube',
      icon: <path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
    },
  ];

  return (
    <footer className="footer">
      <div className="footerContainer">
        {/* Top: brand + tagline */}
        <div className="mb-14 pb-12" style={{ borderBottom: '1px solid rgba(255,255,255,0.07)' }}>
          <Link href="/" className="flex items-center gap-0 mb-4" style={{ textDecoration: 'none', display: 'inline-flex' }}>
            <span className="font-black" style={{ color: '#FFFFFF', letterSpacing: '-0.06em', fontSize: '20px' }}>PADDLE</span>
            <span className="font-black" style={{ color: '#D90012', letterSpacing: '-0.06em', fontSize: '20px' }}>VS</span>
          </Link>
          <p className="text-sm" style={{ color: 'rgba(255,255,255,0.3)', lineHeight: 1.72, maxWidth: 300 }}>
            The independent pickleball paddle comparison platform. Data-driven. No sponsorships.
          </p>
        </div>

        <div
          className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-9 pb-14"
          style={{ borderBottom: '1px solid rgba(255,255,255,0.07)' }}
        >
          {Object.entries(footerLinks).map(([section, links]) => (
            <div key={section}>
              <h3
                className="text-xs font-black uppercase mb-6"
                style={{ color: 'rgba(255,255,255,0.28)', letterSpacing: '0.15em' }}
              >{section}</h3>
              <ul className="space-y-4">
                {links.map(item => (
                  <li key={item.label}>
                    <Link
                      href={item.href}
                      className="text-sm font-medium transition-colors"
                      style={{ color: 'rgba(255,255,255,0.38)', textDecoration: 'none', transitionDuration: '0.2s' }}
                      onMouseEnter={e => ((e.currentTarget as HTMLElement).style.color = '#FFFFFF')}
                      onMouseLeave={e => ((e.currentTarget as HTMLElement).style.color = 'rgba(255,255,255,0.38)')}
                    >{item.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom */}
        <div className="pt-9 flex flex-col md:flex-row items-center justify-between gap-5">
          <p className="text-xs" style={{ color: 'rgba(255,255,255,0.2)', letterSpacing: '0.02em' }}>
            &copy; {year} PaddleVS. All rights reserved. Independent comparison platform.
          </p>

          {/* Social links */}
          <div className="flex items-center gap-2.5">
            {socials.map(social => (
              <a
                key={social.label}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full flex items-center justify-center transition-all"
                style={{
                  background: 'rgba(255,255,255,0.06)',
                  border: '1.5px solid rgba(255,255,255,0.09)',
                  transitionDuration: '0.2s',
                }}
                onMouseEnter={e => {
                  (e.currentTarget as HTMLElement).style.background = '#D90012';
                  (e.currentTarget as HTMLElement).style.borderColor = '#D90012';
                  (e.currentTarget as HTMLElement).style.transform = 'translateY(-3px)';
                  (e.currentTarget as HTMLElement).style.boxShadow = '0 6px 18px rgba(217,0,18,0.36)';
                }}
                onMouseLeave={e => {
                  (e.currentTarget as HTMLElement).style.background = 'rgba(255,255,255,0.06)';
                  (e.currentTarget as HTMLElement).style.borderColor = 'rgba(255,255,255,0.09)';
                  (e.currentTarget as HTMLElement).style.transform = 'translateY(0)';
                  (e.currentTarget as HTMLElement).style.boxShadow = 'none';
                }}
                aria-label={social.label}
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="rgba(255,255,255,0.55)">
                  {social.icon}
                </svg>
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
